import React from 'react'

import { Column } from 'primereact/column'

import {
  AttachmentDownloadButton,
  AttachmentOpenInTabButton,
} from '../../../../../components/attachments'
import { Attachment } from '../../../../../data/models'
import { ConfigurableTable } from '../../../../../utils/wrapper'
import { useConfigContext } from '../../../../ui-config'
import { useDeliveryForecastDespatchAdviceById } from '../../../data'
import { DeleteAttachment, UploadAttachment } from '../dialogs'

type Props = {
  despatchAdviceId: string
}

export const AdditionalDocumentsTable: React.FC<Props> = ({
  despatchAdviceId,
}) => {
  const { uiConfig: config } = useConfigContext()
  const { data, isLoading } =
    useDeliveryForecastDespatchAdviceById(despatchAdviceId)

  // Get other attachments
  const otherAttachments = data?.Attachments.filter(
    item => item.Type.toLowerCase() === 'additional',
  )

  // Action buttons
  const actionBodyTemplate = (rowData: Attachment) => {
    return (
      <>
        <DeleteAttachment
          key={`att-delete-${rowData.Id}`}
          attachmentId={rowData.Id}
          attachmentUrl={rowData.Url as string}
          attachmentName={rowData.Name}
          despatchAdviceId={despatchAdviceId}
        />

        <AttachmentOpenInTabButton
          key={`att-tab-${rowData.Id}`}
          fullUrl={rowData.Url as string}
          mimeType={rowData.MimeType as string}
          fileName={rowData.Name}
        />

        <AttachmentDownloadButton
          key={`att-download-${rowData.Id}`}
          fullUrl={rowData.Url as string}
          mimeType={rowData.MimeType as string}
          fileName={rowData.Name}
        />
      </>
    )
  }

  const attachmentButtons = (
    <Column
      key="attachmentButtons"
      body={actionBodyTemplate}
      align="right"
    ></Column>
  )

  const headerActions = (
    <>
      {config.deliveryForecastDespatchAdvice.uploadAttachment.enabled !==
        false && (
        <UploadAttachment
          despatchAdviceId={despatchAdviceId}
          processId={data?.ProcessId!}
        />
      )}
    </>
  )

  return (
    <ConfigurableTable
      config={
        config?.deliveryForecastDespatchAdvice?.attachment?.additionalDocuments
      }
      data={otherAttachments}
      headerActions={headerActions}
      buttons={attachmentButtons}
      isLoading={isLoading}
      stateKey=""
    />
  )
}
